export default __webpack_public_path__ + "static/media/FreshAirOff.a6acb426.svg";